import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  Alert
} from '@mui/material';

const CreateStocktakeDialog = ({ open, onClose, onSubmit }) => {
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      setLoading(true);
      await onSubmit({ notes: notes.trim() });
      // Reset form
      setNotes('');
      setError('');
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Lỗi tạo phiếu kiểm kho';
      
      // Format the error message for better display
      if (errorMessage.includes('already an active stocktake')) {
        // Extract stocktake info if present
        const match = errorMessage.match(/ID: (\d+), Number: ([^)]+)/);
        if (match) {
          setError(`Không thể tạo phiếu kiểm kho mới.\n\nHiện đang có phiếu kiểm kho ${match[2]} (ID: ${match[1]}) đang hoạt động.\n\nVui lòng hoàn thành hoặc hủy phiếu kiểm kho hiện tại trước khi tạo phiếu mới.`);
        } else {
          setError(errorMessage);
        }
      } else {
        setError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setNotes('');
      setError('');
      onClose();
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          Tạo phiếu kiểm kho mới
        </DialogTitle>
        
        <DialogContent>
          <Box sx={{ pt: 2 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Hệ thống sẽ tự động tạo số phiếu và danh sách sản phẩm cần kiểm khi bắt đầu kiểm kho.
            </Typography>

            {error && (
              <Alert 
                severity="error" 
                sx={{ 
                  mb: 2,
                  whiteSpace: 'pre-line'
                }}
              >
                {error}
              </Alert>
            )}

            <TextField
              fullWidth
              label="Ghi chú (tùy chọn)"
              multiline
              rows={3}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Nhập ghi chú về phiếu kiểm kho này..."
              variant="outlined"
              inputProps={{ maxLength: 500 }}
              helperText={`${notes.length}/500 ký tự`}
            />
          </Box>
        </DialogContent>
        
        <DialogActions>
          <Button 
            onClick={handleClose} 
            disabled={loading}
            color="inherit"
          >
            Hủy
          </Button>
          <Button 
            type="submit"
            variant="contained" 
            disabled={loading}
          >
            {loading ? 'Đang tạo...' : 'Tạo phiếu kiểm kho'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateStocktakeDialog;